import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout")({
    component: () => <IntegrationLayout />,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.scenario.integration.title"),
        };
    },
});

function IntegrationLayout() {
    return <Outlet />;
}
